import api, { API_BASE_URL } from './axiosConfig';
import axios from 'axios';

// Note: api instance and interceptors are already configured in axiosConfig.js

class AuthService {
  async login(username, password, orgId) {
    try {
      const response = await api.post('/login_v2', {
        username,
        password,
        org_id: orgId
      });

      const { access_token, orgs_and_tokens } = response.data;

      // Store tokens and user data in localStorage
      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('orgsAndTokens', JSON.stringify(orgs_and_tokens));

      // Extract user data from JWT token (you might want to decode it)
      // For now, we'll store basic info
      const userData = {
        username,
        orgId,
        loginTime: new Date().toISOString()
      };
      localStorage.setItem('userData', JSON.stringify(userData));

      return {
        success: true,
        data: response.data,
        userData
      };
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Login failed',
        errorType: error.response?.data?.error || 'unknown_error'
      };
    }
  }

  async logout() {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear localStorage regardless of API call success
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('orgsAndTokens');
    }
  }

  async refreshToken() {
    try {
      // Create a separate axios instance for refresh to avoid interceptors
      const refreshApi = axios.create({
        baseURL: API_BASE_URL,
        withCredentials: true,
      });
      
      const response = await refreshApi.post('/token/refresh');
      const { access_token } = response.data;
      localStorage.setItem('accessToken', access_token);
      return { success: true, access_token };
    } catch (error) {
      console.error('Token refresh error:', error);
      return { success: false, error: error.response?.data?.message || 'Token refresh failed' };
    }
  }

  isAuthenticated() {
    const accessToken = localStorage.getItem('accessToken');
    return !!accessToken;
  }

  getUserData() {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  }

  getOrgsAndTokens() {
    const orgsAndTokens = localStorage.getItem('orgsAndTokens');
    return orgsAndTokens ? JSON.parse(orgsAndTokens) : [];
  }

  getCurrentOrgId() {
    const userData = this.getUserData();
    return userData?.orgId;
  }

  // Helper method to get organization name by ID
  getOrgName(orgId) {
    const orgsAndTokens = this.getOrgsAndTokens();
    const org = orgsAndTokens.find(org => org.id === orgId);
    return org ? org.name : null;
  }

  // Helper method to get current environment and API URL
  getEnvironmentInfo() {
    const env = process.env.REACT_APP_ENV || 'local';
    return {
      environment: env,
      apiUrl: API_BASE_URL
    };
  }

  // Helper method to get organization ID based on environment
  getOrganizationId() {
    const env = process.env.REACT_APP_ENV || 'local';
    
    switch (env) {
      case 'local':
      case 'dev':
        return process.env.REACT_APP_DEV_ORG_ID || '';
      case 'prod':
        return process.env.REACT_APP_PROD_ORG_ID || '';
      default:
        return process.env.REACT_APP_DEV_ORG_ID || ''; // Default to dev org ID
    }
  }
}

export default new AuthService(); 